import clsx from "clsx";
import PropTypes from "prop-types";
import * as React from "react";
import { PersonIcon } from "../Icons/Icons";
import { sizeOf } from "../../utils/propTypes";
import css from "./Avatar.module.css";

const Avatar = React.forwardRef(
  ({ src, alt = "", size = "md", className, children, ...rest }, ref) => {
    const [imgError, setImgError] = React.useState(false);

    React.useEffect(() => {
      setImgError(false);
    }, [src]);

    const showImage = src && !imgError;

    return (
      <span
        ref={ref}
        className={clsx(css.root, css[size], className)}
        {...rest}
      >
        {showImage ? (
          <img
            className={css.image}
            src={src}
            alt={alt}
            loading="lazy"
            onError={() => setImgError(true)}
          />
        ) : (
          children || <PersonIcon className={css.fallback} />
        )}
      </span>
    );
  },
);

Avatar.displayName = "Avatar";

Avatar.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string,
  size: sizeOf("sm", "md", "lg"),
  className: PropTypes.string,
  children: PropTypes.node,
};

export default Avatar;
